import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import '@/App.css';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import MembershipModal from '@/components/MembershipModal';
import AdminDashboard from '@/components/AdminDashboard';
import AdminLogin from '@/components/AdminLogin';
import { Toaster } from 'sonner';

function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative z-10">
          {/* CME Logo */}
          <div className="mb-8 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_cme-join-modal/artifacts/wocpjpx8_CME2020-HORIZONTAL.jpg" 
              alt="Creative Media Enterprises Logo"
              className="h-24 w-auto"
              data-testid="cme-logo"
            />
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-bold text-black mb-6 tracking-tight" data-testid="main-heading">
            Member TOS,
            <br />
            <span className="text-cme-red">Privacy Policy</span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-700 mb-10 max-w-2xl mx-auto leading-relaxed" data-testid="main-description">
            Unlock access to premium marketing services, consultation, and creative solutions designed exclusively for our members.
          </p>

          <Button
            onClick={() => setModalOpen(true)}
            className="h-14 px-10 bg-cme-red hover:bg-red-700 text-white text-lg font-semibold shadow-2xl hover:shadow-cme-red/30 transition-all duration-300 transform hover:scale-105 active:scale-95 rounded-lg border-2 border-cme-gold"
            data-testid="join-membership-button"
          >
            Join CME Membership
          </Button>

          <p className="mt-6 text-sm text-gray-600 flex items-center justify-center gap-2">
            <Shield className="w-4 h-4 text-cme-gold" />
            Secure · Private · Professional
          </p>

          {/* Admin Link */}
          <div className="mt-8">
            <Link 
              to="/admin" 
              className="text-sm text-gray-500 hover:text-cme-red transition-colors"
            >
              Admin Dashboard →
            </Link>
          </div>
        </div>
      </div>

      <MembershipModal open={modalOpen} onOpenChange={setModalOpen} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;